/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_CountInputs */

const en_orders_count = /** @type {(inputs: Orders_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} orders)`)
};

const es_orders_count = /** @type {(inputs: Orders_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`(${i?.count} pedidos)`)
};

/**
* | output |
* | --- |
* | "({count} orders)" |
*
* @param {Orders_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_count = /** @type {((inputs: Orders_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_count(inputs)
	return es_orders_count(inputs)
});